import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { useNavigate } from '@thd-olt-component-react/router';
import { clickEvents } from '../../utils/analytics';
import { AUTH_FORM_PATH, MY_ACCOUNT_ROUTES } from '../../utils/constants';
import { useStore } from '../../store/index';

const SplashPageButton = ({
  buttonText, destination, analyticsLabel, variant, fullWidth
}) => {

  const {
    authStore: { authorized, errorCode }
  } = useStore();

  const navigate = useNavigate();

  const handleClick = () => {
    analyticsLabel && clickEvents.landingPageLinkClick(analyticsLabel);
    if (authorized) {
      navigate(destination);
    } else if (errorCode === 9) {
      window.location.replace(`${AUTH_FORM_PATH}?redirect=${destination}`);
    } else if (errorCode === 25 || errorCode === 26) {
      navigate(
  `${MY_ACCOUNT_ROUTES.UPGRADE_PROFILE}&redirect=${encodeURIComponent(destination)}`);
    }
  };

  return (
    <Button
      variant={variant}
      fullWidth={fullWidth}
      onClick={handleClick}
    >
      {buttonText}
    </Button>
  );
};

export default SplashPageButton;
